import React from 'react';

const MedicationTypeHelp: React.FC = () => {
  return (
    <details className="resus-admin__help">
      <summary>איך מגדירים תרופה? — מדריך קצר</summary>

      <h4>1. תרופה במשקל (drug, type = mass)</h4>
      <p>
        תרופה הניתנת לפי מינון משקל ישירות בתחומיה (mg, mcg, units). אין צורך בריכוז.
        דוגמה: <code>Hydrocortisone</code> — <code>4 mg/kg IV</code>. שדות חיוניים:
        <code>name</code>, <code>dose_per_kg</code>, <code>dose_unit</code>, <code>type = "mass"</code>.
      </p>

      <h4>2. תרופה בנוזל / בולוס (drug, type = fluid)</h4>
      <p>
        בולוס נוזלים, חישוב לפי משקל בליטר/מ״ל. דוגמה: <code>NaCl 0.9%</code> — <code>20 ml/kg IV</code>.
        שדות חיוניים: <code>name</code>, <code>dose_per_kg</code>, <code>dose_unit = "ml"</code>,
        <code>type = "fluid"</code>.
      </p>

      <h4>3. תרופה בריכוז (drug, type לא מוגדר)</h4>
      <p>
        תרופה במינון ידוע בריכוז ידוע. נחשב את הנפח להזרקה. דוגמה: <code>Adrenaline 1:10,000</code> —
        <code>0.01 mg/kg</code> בריכוז <code>1/10</code>. שדות חיוניים:
        <code>name</code>, <code>dose_per_kg</code>, <code>dose_unit</code>, <code>concentration</code>.
        אופציונלי: <code>maxDose</code>, <code>minDose</code>.
      </p>

      <h4>4. דריפ עם הוראות דילול (drip, calc_type = DilutionInstructions)</h4>
      <p>
        תרופה רציפה שצריך לדלל לפני מתן. המערכת תחשב כמה מהתרופה להוסיף לנפח הסופי.
        דוגמה: <code>Adrenaline drip</code> — <code>0.1 mcg/kg/min</code> בנפח סופי <code>50ml</code>.
        שדות חיוניים: <code>dose_per_kg_per_min</code> (או <code>dose_per_kg_per_hour</code>),
        <code>default_dilution_volume_ml</code>, <code>target_volume_ml_per_hour</code>.
      </p>

      <h4>5. דריפ במהירות הזלפה (drip, calc_type = InfusionSpeed)</h4>
      <p>
        תרופה רציפה כשהריכוז כבר ידוע. המערכת תחשב רק את מהירות ההזלפה.
        דוגמה: <code>Potassium</code> — <code>0.2 mmol/kg/hour</code> בריכוז <code>40/1000</code>.
        שדות חיוניים: <code>dose_per_kg_per_hour</code>, <code>existing_dilution_concentration</code>.
        אופציונלי: <code>max_dose_per_hour</code>.
      </p>

      <h4>תכונות מתקדמות</h4>
      <p>
        <strong>cases (תנאי משקל/גיל):</strong> אם המינון משתנה לפי משקל או גיל
        (למשל פניטואין במשקלים שונים), הוסיפו רשומות במקטע "תנאי משקל" או "תנאי גיל".
        המערכת תזהה אוטומטית את הרשומה המתאימה למטופל.
      </p>
      <p>
        <strong>קטגוריות (drugSections):</strong> ניתן לשייך תרופה ל"קבוצות תרופות"
        (החייאה, סדציה, אנטידוטים וכו'). הקבוצות עצמן נטענות מברירת המחדל ולא ניתנות לעריכה ב-V1.
      </p>
      <p>
        <strong>הקצאה לפרוטוקולים:</strong> משויכת בשלב 3 של האשף. אפשר גם לשייך מהיר במסך זה
        על ידי לחיצה על "שיוך לפרוטוקולים".
      </p>
    </details>
  );
};

export default MedicationTypeHelp;
